







import { Component, Vue } from "vue-property-decorator";
import {
  Company,
  getOtherCompanies,
  updateFavoriteCompany
} from "@/api/company-api";

import CompanyList from "@/templates/CompanyList.vue";

import GroupFilter from "@/entities/group-filter";

@Component({
  components: {
    CompanyList
  }
})
export default class CompanyListPage extends Vue {
  select({ id }: { id: number }) {
    const params = { id: String(id) };
    this.$router.push({ name: "companies-show", params });
  }

  create() {
    this.$router.push({ name: "companies-new" });
  }

  search(query: string) {
    this.query = query;
  }

  filter(role: string) {
    this.companyRole = role;
  }

  async updateFavorite(companyId: number, favorite: boolean) {
    await updateFavoriteCompany(companyId, favorite);
    await this.initCompanies();
  }

  get companies() {
    return this.rawCompanies.filter(c => this.searchFilter.isSatisfied(c));
  }

  private rawCompanies: Company[] = [];
  private query = "";
  private companyRole: string = "";

  private get searchFilter() {
    return new GroupFilter({
      query: this.query,
      role: this.companyRole
    });
  }

  public created() {
    this.initCompanies();
  }

  private async initCompanies() {
    this.rawCompanies = await getOtherCompanies();
  }
}
